import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import ALink from '../utils/alink';
import { scrollTopHandler } from '../utils/index';

function SidebarFilterThree({filterData}) {
    const router = useLocation();
    const [ isFirst, setFirst ] = useState( true );
    const query = router.query;
    useEffect( () => {
        window.addEventListener( 'resize', resizeHandler, false );
        document.querySelector( "body" ).addEventListener( "click", onBodyClick );

        return () => {
            window.removeEventListener( 'resize', resizeHandler );
            document.querySelector( "body" ).removeEventListener( "click", onBodyClick );
        }
    }, [] )

    useEffect( () => {
        if ( isFirst ) {
            setFirst( false );
        } else {
            scrollTopHandler();
        }
    }, [ query ] )

    const containsAttrInUrl = ( type, value ) => {
        const currentQueries = query[ type ] ? query[ type ].split( ',' ) : [];
        if ( type === 'min_price' || type === 'max_price' ) {
            return currentQueries && ( ( value === '' && currentQueries.length === 0 ) || currentQueries.includes( value ) )
        } else {
            return currentQueries && currentQueries.includes( value );
        }
    }

    const getUrlForAttrs = ( type, value ) => {
        let currentQueries = query[ type ] ? query[ type ].split( ',' ) : [];
        if ( type === 'min_price' || type === 'max_price' ) {
            currentQueries = currentQueries.length > 0 && currentQueries.includes( value ) ? [] : [ value ]
        } else {
            currentQueries = containsAttrInUrl( type, value ) ? currentQueries.filter( item => item !== value ) : [ ...currentQueries, value ];
        }
        return currentQueries.join( ',' );
    }

    const selectOptionHandler = function ( e ) {
        e.preventDefault();
        e.currentTarget.closest( '.toolbox-item.select-menu' ).classList.toggle( 'opened' );
    }

    function onBodyClick( e ) {
        ( e.target.closest( '.select-menu.opened' ) || ( document.querySelector( '.select-menu.opened' ) ) && document.querySelector( '.select-menu.opened' ).classList.remove( 'opened' ) );
    }

    const hideSidebar = () => {
        document.querySelector( 'body' ).classList.remove( "sidebar-active" );
    }

    const resizeHandler = () => {
        document.querySelector( 'body' ).classList.remove( "sidebar-active" );
    }

    const selectFilterHandler = ( e ) => {
        setTimeout( () => {
            if ( document.querySelector( '.select-items' ).children.length > 1 ) {
                document.querySelector( '.select-items' ).setAttribute( 'style', 'visibility: visible; opacity: 1; height: auto; margin-top: 2px; margin-bottom: 1.8rem' )
            } else {
                document.querySelector( '.select-items' ).setAttribute( 'style', '' )
            }
        }, 100 )
    }

    return (
        <aside className="sidebar shop-sidebar sidebar-fixed">
            <div className="sidebar-overlay" onClick={ hideSidebar }></div>
            <ALink className="sidebar-close" href="#" onClick={ hideSidebar }><i className="d-icon-times"></i></ALink>

            <div className="sidebar-content toolbox-left">
                <div className="toolbox-item select-menu">
                    <a className="select-menu-toggle" href="#" onClick={ selectOptionHandler }>Select Size</a>

                    <ul className="filter-items">
                        {
                            filterData.sizes.map( ( item, index ) =>
                                <li
                                    className={ containsAttrInUrl( 'sizes', item.slug ) ? 'active' : '' }
                                    key={ item + ' - ' + index }
                                    onClick={ selectFilterHandler }
                                >
                                    <ALink href={ { pathname: router.pathname, query: { ...query, page: 1, sizes: getUrlForAttrs( 'sizes', item.slug ) } } } scroll={ false }>{ item.name }
                                    </ALink>
                                </li>
                            )
                        }
                    </ul>
                </div>

                <div className="toolbox-item select-menu">
                    <a className="select-menu-toggle" href="#" onClick={ selectOptionHandler }>Select Color</a>

                    <ul className="filter-items">
                        {
                            filterData.colors.map( ( item, index ) =>
                                <li
                                    className={ containsAttrInUrl( 'colors', item.slug ) ? 'active' : '' }
                                    key={ item + ' - ' + index }
                                    onClick={ selectFilterHandler }
                                >
                                    <ALink href={ { pathname: router.pathname, query: { ...query, page: 1, colors: getUrlForAttrs( 'colors', item.slug ) } } } scroll={ false }>{ item.name }
                                    </ALink>
                                </li>
                            )
                        }
                    </ul>
                </div>
            </div>
        </aside >
    )
}

export default ( SidebarFilterThree );